export function adjustInputWidth(el) {
  const span = document.createElement("span");
  span.style.visibility = "hidden";
  span.style.position = "absolute";
  span.style.whiteSpace = "pre";

  const computed = window.getComputedStyle(el);
  span.style.font = computed.font;
  span.style.fontSize = computed.fontSize;
  span.style.fontWeight = computed.fontWeight;
  span.style.fontFamily = computed.fontFamily;
  span.style.letterSpacing = computed.letterSpacing;

  span.textContent = el.value || el.placeholder || "0";

  document.body.appendChild(span);
  const contentWidth = span.offsetWidth;
  const extraWidth = parseInt(el.dataset.extraWidth, 10) || 0;
  el.style.width = contentWidth + extraWidth + "px";
  document.body.removeChild(span);
}

export const AutoWidthInput = {
  mounted() {
    adjustInputWidth(this.el);
    this.el.addEventListener("input", () => adjustInputWidth(this.el));
  },

  updated() {
    adjustInputWidth(this.el);
  },
};
